export default __webpack_public_path__ + "static/media/underscore.1978df4d.svg";